import 'regenerator-runtime/runtime';
import 'current-script-polyfill';
import 'bootstrap';
import 'blocks/bootstrap.less';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'blocks/migration/list.scss'; // escoList .panel
import 'blocks/migration/errors.css';
import '@selectize/selectize/dist/css/selectize.bootstrap3.css';
import 'blocks/style.css';
import { addConfigFromSolutions } from '@entryscape/es-utils';

const init = async () => {
  await addConfigFromSolutions();

  const initDefaults = await import(
    /* webpackChunkName: "initDefaults" */ './defaults'
  );
  await initDefaults.default();
};

export default init();
